import { AccountCategory, MasterTask } from "./index";
import { Template } from './template';

export class Task {
    //base properties
    templateId: number;
    masterTaskId: number;
    startDay: number;
    duration?: number;
    paymentTrigger?: number;
    isActive: boolean;
    isPendingRemoval: boolean;

    //navigation properties
    template: Template;
    masterTask: MasterTask;

    //non-base properties
    isAdd: boolean;
    
    acctCat: AccountCategory;
}
